import { importAll } from 'utils/helperFunctions';

export const templates = importAll(
  require.context('../../assets/templates', false, /\.(png|jpe?g|svg)$/),
);
